import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

// Avoid noisy NavigationDuplicated errors for repeated navigation to the same route.
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Download v18.80 Pro APK 2026 | Real | Latest',
			keywords: 'gb whatsapp, gb whatsapp download, gb whatsapp apk, gb whatsapp pro, gbwhata.io',
			description: 'Download the latest GB WhatsApp v18.80 Pro APK for Android in 2026. Enjoy extra privacy options, custom themes, dual Wa App accounts, and better media sharing in one app.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Download GBWA App Apk for Free',
			keywords: 'gbwa download, gb whatsapp apk download, gb whatsapp download, gb whatsapp v18.80',
			description: 'Download the GBWA app APK for free on your Android device. Get the latest GBWhatsApp version. Safe & fast APK download available now.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/guide/',
		name: 'en-guide',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Guides - Tips, How-To & Troubleshooting',
			keywords: 'gb whatsapp guide, whatsapp tips, gb whatsapp help, whatsapp troubleshooting',
			description: 'Find practical GB WhatsApp guides for installation, updates, backups, privacy settings, features, troubleshooting, and common problems.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/guide/'
				}
			]
		},
		component: () => import('@/views/guide.vue'),
	},
	{
		path: '/meta-ai-advantages/',
		alias: '/guide/meta-ai-advantages/',
		name: 'en-meta-ai-advantages',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Use Meta AI on GB WhatsApp | Advantages and Effectiveness',
			keywords: 'meta ai whatsapp, meta ai gb whatsapp, whatsapp ai features, meta ai stickers',
			description: 'Explore how Meta AI on WhatsApp enhances user experience with AI-driven features like content creation, business ideas, personalized stickers, and real-time information - all without sign-up.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/meta-ai-advantages/'
				}
			]
		},
		component: () => import('@/views/guide-meta-ai.vue'),
	},
	{
		path: '/share-view-once-photos/',
		alias: '/guide/share-view-once-photos/',
		name: 'en-share-view-once-photos',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Methods to Share View Once Photos on WhatsApp 2026',
			keywords: 'view once photos, whatsapp view once, share view once photos, gb whatsapp media',
			description: 'Do you know how to share view once photos on WhatsApp? Read this guide to get the detailed steps. And you can also try GBWhatsApp.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/share-view-once-photos/'
				}
			]
		},
		component: () => import('@/views/guide-view-once.vue'),
	},
	{
		path: '/privacy/',
		name: 'en-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy | gbwhata.io',
			keywords: 'gbwhata.io privacy policy, website privacy, gb whatsapp site policy',
			description: 'Read the gbwhata.io privacy policy to learn what site information may be collected, how it is used, and how third-party links are handled.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/privacy/'
				}
			]
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer | gbwhata.io',
			keywords: 'gbwhata.io disclaimer, gb whatsapp disclaimer, third party apk risk',
			description: 'Read the gbwhata.io disclaimer covering third-party APK downloads, account risk, data loss, external links, and lack of affiliation with WhatsApp or Meta.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhata.io/disclaimer/'
				}
			]
		},
		component: () => import('@/views/disclaimer.vue'),
	},
]

const routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})
}
